import { render, staticRenderFns } from "./TrustedReviews.vue?vue&type=template&id=7370a878&scoped=true"
import script from "./TrustedReviews.vue?vue&type=script&lang=js"
export * from "./TrustedReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7370a878",
  null
  
)

export default component.exports